/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { Badge, Button } from 'reactstrap';

export const BundlePricingCallToAction = () => {

  const handleClick = () => {
    window.open('https://companytracker.g17.eco/#pricing');
  };

  return (
    <div>
      <Button color='transparent' size='sm' outline className='btn-pill' onClick={() => handleClick()}>
        <Badge color='success' pill className='outline mr-2 px-3 py-0 text-sm fw-normal'>New</Badge>
        See our bundle pricing for Company Tracker
        <i className='fal fa-arrow-right-long ml-2' />
      </Button>
    </div>
  );
}

